/**
 * assets/js/src/aktfoto.js -- sipky fotopasu deseti aktivit na strance
 * Outdoor aktivity (`.aktfoto`/`.afnav`).
 *
 * PORT 1:1 z `navrh-th-outdoor-aktivity.html:1389-1403` (AR, nalez
 * majitele 7. 9.: predchozi verze fotopasu stavela na sdilenem
 * `carousel.php`, ktery nechaval po strane viditelny nativni scrollbar
 * a mel jine mezery). Logika je bajtove stejna jako v mockupu -- jedina
 * zmena je `var` -> `let`/`const` (kontrakt lint-js-src.sh, `no-var`,
 * plati pro cely `assets/js/src`).
 *
 * SAMOSTATNY BUNDLE (`build:js:aktfoto`), NE `index.js`: sekce je jen na
 * jedne strance webu, stejny duvod jako u `thankyou-game.js`/`game-map.js`
 * -- kdo tuhle stranku nikdy neuvidi, soubor si nestahuje. Enqueue je
 * podminena `is_page_template( 'page-templates/template-outdoor.php' )`
 * v `inc/assets.php` (`terrahunt_2026_enqueue_outdoor_aktfoto()`).
 */
(function () {
	const pruh = document.querySelector('.aktfoto');
	if (!pruh) {
		return;
	}

	const vlevo = document.querySelector('.afnav.prev'),
		vpravo = document.querySelector('.afnav.next');

	if (!vlevo || !vpravo) {
		return;
	}

	function stav() {
		const pretok = pruh.scrollWidth - pruh.clientWidth > 4;
		vlevo.classList.toggle('show', pretok && pruh.scrollLeft > 4);
		vpravo.classList.toggle('show', pretok && pruh.scrollLeft < pruh.scrollWidth - pruh.clientWidth - 4);
	}

	const krok = function () {
		return Math.round(pruh.clientWidth * 0.8);
	};

	vlevo.addEventListener('click', function () {
		pruh.scrollBy({ left: -krok(), behavior: 'smooth' });
	});
	vpravo.addEventListener('click', function () {
		pruh.scrollBy({ left: krok(), behavior: 'smooth' });
	});
	pruh.addEventListener('scroll', stav);

	if ('ResizeObserver' in window) {
		new ResizeObserver(stav).observe(pruh);
	}

	stav();
})();
